import React from 'react';
import { genptTestStatus } from '../../../../../utils/constants/genpt';

/**
 * Last-run status badge for one saved-scenario dropdown row (AC3, ROAR-4840). Shared by
 * `DefineScenarioSection` (chat define flow) and `SavedScenarioPicker` (CI/CD select flow, ROAR-4511)
 * so both render the identical pill. Renders nothing for an unknown/absent status.
 */
export default function ScenarioStatusBadge({ status }) {
  const meta = genptTestStatus[status];
  if (!meta) return null;
  return (
    <span
      className="rounded-[10px] px-2 py-0.5 text-[10px] text-white whitespace-nowrap"
      style={{ backgroundColor: meta.bg_color }}
    >
      {meta.title}
    </span>
  );
}
